// src/components/ui/Card.js
import React from 'react';

export function Card({ children, className = '', header, footer, padding = 'p-6' }) {
  return (
    <div className={`bg-white rounded-xl shadow-soft border border-gray-100 overflow-hidden transition-all hover:shadow-premium ${className}`}>
      {header && (
        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/30">
          {typeof header === 'string' ? (
            <h3 className="text-lg font-bold text-gray-900">{header}</h3>
          ) : header}
        </div>
      )}
      
      <div className={padding}>
        {children}
      </div>

      {footer && (
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/10">
          {footer}
        </div>
      )}
    </div>
  );
}

export function CardGrid({ children, cols = 1, gap = 6 }) {
  const colStyles = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <div className={`grid ${colStyles[cols]} gap-${gap}`}>
      {children}
    </div>
  );
}
